export default __webpack_public_path__ + "static/media/medicine.74dc16de.png";